import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';
import type { AttachedInitiative } from '/business/shared/state/reducers/basket';

export default (state: RootState): AttachedInitiative[] => state.basket?.meta?.reductionInitiatives || EMPTY_ARRAY;
